<template>
    <div
        class="modal fade"
        id="duplicatedCustomerReferenceModal"
        tabindex="-1"
        aria-labelledby="duplicatedCustomerReferenceModalLabel"
    >
        <div class="modal-dialog" style="max-width: 600px; width: 90vw;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="duplicatedCustomerReferenceModalLabel">
                        Customer Reference: {{ customerReference }}
                    </h5>
                </div>
                <div class="modal-body">
                    <div>
                        A quote for this customer reference already exists. <strong>What would you like to do?</strong>
                    </div>
                </div>
                <div class="modal-footer d-flex flex-column gap-2 text-center" style="flex-wrap: wrap;">
                    <button class="btn btn-danger btn-sm mb-3" style="min-width: 0;" @click="doCancelSearch()">
                        Cancel the search
                    </button>
                    <button class="btn btn-success btn-sm mb-3" style="min-width: 0;" @click="doContinueSameReference()">
                        Continue with same customer reference
                    </button>
                    <button class="btn btn-primary btn-sm mb-2" style="min-width: 0;" @click="doContinueDifferentReference()">
                        Continue with a different customer reference
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DuplicatedCustomerReferenceModal",
    props: {
        customerReference: {
            type: String,
            required: true,
        },
    },
    methods: {
        doContinueSameReference() {
            this.$emit('doContinueSameReference')
        },
        doContinueDifferentReference() {
            this.$emit('doContinueDifferentReference')
        },
        doCancelSearch() {
            this.$emit('doCancelSearch')
        },
    },
};

</script>
